import { classNames } from '../utilities';
export const PdfIcon = ({ className, onClick }) => {
  return (
    <svg
      className={classNames(' cursor-pointer', className ? className : '')}
      onClick={onClick ? onClick : () => null}
      width="20"
      height="23"
      viewBox="0 0 22 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.7143 0C3.85001 0 3.14287 0.707143 3.14287 1.57143V23.5714C3.14287 24.4357 3.85001 25.1429 4.7143 25.1429H20.4286C21.2929 25.1429 22 24.4357 22 23.5714V6.28572L15.7143 0H4.7143Z"
        fill="#ffffff"
      />
      <path
        d="M17.2857 6.28572H22L15.7143 0V4.71429C15.7143 5.57857 16.4214 6.28572 17.2857 6.28572Z"
        fill="#B0B7BD"
      />
      <path d="M22 11.0002L17.2857 6.28589H22V11.0002Z" fill="#CAD1D8" />
      <path
        d="M18.8571 20.4288C18.8571 20.8609 18.5036 21.2145 18.0714 21.2145H0.785714C0.353571 21.2145 0 20.8609 0 20.4288V12.5716C0 12.1395 0.353571 11.7859 0.785714 11.7859H18.0714C18.5036 11.7859 18.8571 12.1395 18.8571 12.5716V20.4288Z"
        fill="#F15642"
      />
      <path
        d="M3.42493 14.8866C3.42493 14.6792 3.58836 14.4529 3.85157 14.4529H5.30278C6.11993 14.4529 6.85535 14.9997 6.85535 16.0479C6.85535 17.041 6.11993 17.5942 5.30278 17.5942H4.25385V18.4239C4.25385 18.7005 4.07785 18.8568 3.85157 18.8568C3.64414 18.8568 3.42493 18.7005 3.42493 18.4239V14.8866ZM4.25385 15.2441V16.8092H5.30278C5.72393 16.8092 6.05707 16.4376 6.05707 16.0479C6.05707 15.6087 5.72393 15.2441 5.30278 15.2441H4.25385Z"
        fill="white"
      />
      <path
        d="M8.08575 18.8576C7.87832 18.8576 7.65204 18.7445 7.65204 18.4687V14.9C7.65204 14.6745 7.87832 14.5103 8.08575 14.5103H9.5244C12.3954 14.5103 12.3325 18.8576 9.58097 18.8576H8.08575ZM8.48175 15.2771V18.0915H9.5244C11.2208 18.0915 11.2962 15.2771 9.5244 15.2771H8.48175Z"
        fill="white"
      />
      <path
        d="M13.3508 15.3275V16.3261H14.9529C15.1792 16.3261 15.4055 16.5524 15.4055 16.7716C15.4055 16.979 15.1792 17.1487 14.9529 17.1487H13.3508V18.468C13.3508 18.688 13.1945 18.8569 12.9745 18.8569C12.6979 18.8569 12.529 18.688 12.529 18.468V14.8992C12.529 14.6737 12.6987 14.5095 12.9745 14.5095H15.18C15.4565 14.5095 15.62 14.6737 15.62 14.8992C15.62 15.1004 15.4565 15.3267 15.18 15.3267H13.3508V15.3275Z"
        fill="white"
      />
      <path
        d="M18.0714 21.2144H3.14287V22.0001H18.0714C18.5036 22.0001 18.8572 21.6466 18.8572 21.2144V20.4287C18.8572 20.8609 18.5036 21.2144 18.0714 21.2144Z"
        fill="#CAD1D8"
      />
    </svg>
  );
};
